import { Record } from 'immutable';
import { Utils } from '@kineticdata/bundle-common';
const { withPayload } = Utils;
const ns = Utils.namespaceBuilder('app/staff');

export const types = {
  FETCH_STAFF_REQUEST: ns('FETCH_STAFF_REQUEST'),
  FETCH_STAFF_SUCCESS: ns('FETCH_STAFF_SUCCESS'),
  FETCH_STAFF_FAILURE: ns('FETCH_STAFF_FAILURE'),
};

export const actions = {
  fetchStaffRequest: withPayload(types.FETCH_STAFF_REQUEST),
  fetchStaffSuccess: withPayload(types.FETCH_STAFF_SUCCESS),
  fetchStaffFailure: withPayload(types.FETCH_STAFF_FAILURE),
};

export const State = Record({
  data: null,
  error: null,
});

export const reducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_STAFF_REQUEST:
      return state.set('data', null).set('error', null);
    case types.FETCH_STAFF_SUCCESS:
      return state.set('data', payload);
    case types.FETCH_STAFF_FAILURE:
      return state.set('error', payload);
    default:
      return state;
  }
};
